module.exports = __webpack_public_path__ + "img/lock.a3c2c632.svg";